import { render } from "./Payment.view.vue?vue&type=template&id=d5393a50"
import script from "./Payment.view.vue?vue&type=script&lang=js"
export * from "./Payment.view.vue?vue&type=script&lang=js"

import "./Payment.view.vue?vue&type=style&index=0&id=d5393a50&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__